import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as loginActions } from "./index";
// import styles from "./login.module.css";
import { Redirect } from "react-router-dom";
import { Row, Col,message,Icon } from "antd";
import HomebackDrop from "../components/images/backdropHome.png";
import HomebackDropTwo from "../components/images/backdropHome_2.png";
import VedicLogo from "../components/images/vedic_logo.png";
import GoogleButton from "react-google-button";

class LoginPage extends Component {
  componentWillUnmount() {
    this.props.onUnload();
  }
  
  render() {
    const { auth, firebase } = this.props;
    
    

    // if(auth && !auth.isLoaded || firebase && !firebase.profile.isLoaded){
    //   return <div style={{textAlign:'center',marginTop:50}}><Icon type={"loading"}></Icon> Please wait..</div>
    // }

    if (auth && auth.isLoaded && !auth.isEmpty && firebase && firebase.profile && !firebase.profile.isEmpty && firebase.profile.profileCurrentStep === 11) {
     
      return <Redirect to={`/home/campusDashboard/${firebase.profile.campus}`} />
    }

    if (auth && auth.isLoaded && !auth.isEmpty  && firebase && firebase.profile && !firebase.profile.isEmpty && firebase.profile.profileCurrentStep !== 11) {
      if(firebase.profile.role=='ADMIN'){
        return <Redirect to={`/home/campusDashboard/${firebase.profile.campus}`} />
      }
      else{
      return <Redirect to="/home/overview" />
      }
    }

    // if (auth.uid) return <Redirect to="/home/overview" />;

    const gotoLogin = e => {
      e.preventDefault();
      this.props.login({});
    };

    return (
      <>
        {/* <div className={styles.header}>
          <div className={styles["header-wrapper"]}>
            <header>
              <a href="/">
              <img src="http://www.srivishnu.edu.in/wp-content/uploads/2018/07/footer_logo.png" alt="logo" />
                <h2>Vedic Platform</h2>
              </a>
            </header>
          </div>
        </div> */}

        {/* <Row style={{backgroundColor:'#039BE5', height:'100vh',backgroundRepeat:'no-repeat',backgroundPositionX:'-100%' ,backgroundImage:`url(${HomebackDrop})`}}> */}
        <Row
          type="flex"
          justify="space-around"
          align="middle"
          style={{
            backgroundSize: "cover",
            backgroundColor: "#039BE5",
            backgroundRepeat: "no-repeat",
            height: "100%",
            backgroundImage: `url(${HomebackDropTwo})`
          }}
        >
          <Col xs={24} sm={24} md={24} lg={10} xl={10} style={{ padding: 10 }}>
            <div
              style={{
                borderStyle: "solid",
                borderRadius: "7px",
                backgroundColor: "rgba(60, 100, 119, 0.65)",
                padding: "25px",
                textAlign: "center",
                borderColor: "rgb(95, 148, 214)",
                borderWidth: "2px",
                WebkitBoxShadow: "0px 0px 8px 5px rgba(223,220,242,1)",
                MozBoxShadow: "0px 0px 8px 5px rgba(223,220,242,1)",
                boxShadow: "0px 0px 8px 5px rgba(223, 220, 242, 0.53)"
              }}
            >
              <img style={{ marginBottom: 20 }} src={VedicLogo}></img>
              <h2
                style={{
                  marginBottom: "25px",
                  fontSize: "16px",
                  color: "#fff1f1"
                }}
              >
                Skills - Projects - Competitive Programming
              </h2>
              <GoogleButton
                style={{ width: "100%" }}
                label="Sign in with Google to continue"
                onClick={gotoLogin}
              />
            </div>
          </Col>

          {/* <Row type="flex" justify="end" align="middle" style={{marginTop:'10%'}}>
      <Col span={10}>
        <div  style={{"borderRadius":"20px","width":"75%","backgroundColor":"#058cd4","padding":"60px"}}> 
        <img src={VedicLogo}></img>
        <GoogleButton
        label='Sign in with Google'
        onClick={gotoLogin}
/>
        </div>
        </Col> */}
        </Row>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    firebase: state.firebase
  };
};

const mapDispachToProps = (dispatch, props) => ({
  login: formValue => {
    dispatch(loginActions.login(formValue, props.history));
  },
  onUnload: () =>
  dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(LoginPage);
